export default __webpack_public_path__ + "static/media/grid_image.f86fc2e8.svg";